import React from 'react';
import { noop } from 'underscore';
import Draggable, {
  DraggableProvider,
  DraggableProviderProps,
} from 'components/Draggable';
import { useTrackAssetContext } from './TrackAssetContext';

export type TrackAssetContainerProps = {
  children?: React.ReactElement | DraggableProviderProps['children'];
  dragParentHandle?: string;
  onMouseDown?: (e: React.MouseEvent<HTMLElement>) => void;
};

function isChildRenderFunction(
  children: React.ReactNode,
): children is DraggableProviderProps['children'] {
  return typeof children === 'function';
}

function TrackAssetContainer(props: TrackAssetContainerProps) {
  const { children, dragParentHandle, onMouseDown = noop } = props;

  const {
    containerId,
    dragBounds,
    handleDrag,
    handleDragStart,
    handleDragStop,
    position,
  } = useTrackAssetContext();

  return (
    <Draggable
      bounds={dragBounds}
      handle={`#${containerId}`}
      onMouseDown={onMouseDown}
      parentHandle={dragParentHandle}
      position={position}
      onDrag={handleDrag}
      onStart={handleDragStart}
      onStop={handleDragStop}
    >
      {isChildRenderFunction(children) ? (
        <DraggableProvider>{children}</DraggableProvider>
      ) : (
        <>{children}</>
      )}
    </Draggable>
  );
}

export default TrackAssetContainer;
